"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.number.constructor");
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _activeBinding = require("@/api/activeBinding");
var _ossUpload = require("@/utils/ossUpload");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      dialogVisible: false,
      tableData: [],
      picImg: null,
      // 图片
      rules: {},
      modelId: null
    };
  },
  methods: {
    onDelIcon: function onDelIcon() {
      this.picImg = '';
    },
    onSaveIcon: function onSaveIcon() {
      this.headlineUploadPicApi();
    },
    open: function open(data) {
      this.modelId = data.id;
      this.dialogVisible = true;
      this.headlineListApi();
    },
    onClose: function onClose() {
      this.queryData = {};
      this.dialogVisible = false;
    },
    handleAvatarSuccess: function handleAvatarSuccess() {},
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(_ref) {
        var file, pictureUrl, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              file = _ref.file;
              _context.p = 1;
              _context.n = 2;
              return (0, _ossUpload.uploadOSS)(file);
            case 2:
              pictureUrl = _context.v;
              this.picImg = pictureUrl;
              // this.headlineUploadPicApi()
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.log('error ->', _t);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function handleFileUpload(_x) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    onSave: function onSave(data) {
      if (!this.picImg) {
        this.$message({
          type: 'warning',
          message: '请先上传图片!'
        });
        return;
      }
      if (data.id) {
        this.headlineUpdateApi(data.id, data.content);
      } else {
        this.headlineSaveApi(data.content);
      }
    },
    onDelete: function onDelete(data, index) {
      var _this = this;
      if (data.id) {
        this.$confirm('是否确认删除此活动?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          _this.headlineDeleteApi(Number(data.id));
        });
      } else {
        this.tableData.splice(index, 1);
      }
    },
    onAdd: function onAdd() {
      this.tableData.push({
        content: '',
        pic: ''
      });
    },
    headlineListApi: function () {
      var _headlineListApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, ProcessingList, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = {
                modelId: this.modelId
              };
              _context2.n = 1;
              return (0, _activeBinding.headlineListApi)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                ProcessingList = [];
                res.data.headlineList.forEach(function (item) {
                  item.inputState = true;
                  ProcessingList.push(item);
                });
                this.tableData = ProcessingList;
                this.picImg = res.data.pic;
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function headlineListApi() {
        return _headlineListApi2.apply(this, arguments);
      }
      return headlineListApi;
    }(),
    headlineSaveApi: function () {
      var _headlineSaveApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3(content) {
        var params, res, _t3;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              params = {
                content: content
              };
              _context3.n = 1;
              return (0, _activeBinding.headlineSaveApi)(params);
            case 1:
              res = _context3.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '保存成功'
                });
                this.headlineListApi();
                this.$parent.getHeaderMsg(this.modelId);
              }
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              console.log(_t3);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function headlineSaveApi(_x2) {
        return _headlineSaveApi2.apply(this, arguments);
      }
      return headlineSaveApi;
    }(),
    headlineUpdateApi: function () {
      var _headlineUpdateApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4(id, content) {
        var params, res, _t4;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              params = {
                id: id,
                content: content
              };
              _context4.n = 1;
              return (0, _activeBinding.headlineUpdateApi)(params);
            case 1:
              res = _context4.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '编辑成功'
                });
                this.headlineListApi();
                this.$parent.getHeaderMsg(this.modelId);
              }
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t4 = _context4.v;
              console.log(_t4);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function headlineUpdateApi(_x3, _x4) {
        return _headlineUpdateApi2.apply(this, arguments);
      }
      return headlineUpdateApi;
    }(),
    headlineDeleteApi: function () {
      var _headlineDeleteApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5(id) {
        var params, res, _t5;
        return (0, _regenerator2.default)().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              params = {
                id: id
              };
              _context5.n = 1;
              return (0, _activeBinding.headlineDeleteApi)(params);
            case 1:
              res = _context5.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '删除成功'
                });
                this.headlineListApi();
                this.$parent.getHeaderMsg(this.modelId);
              }
              _context5.n = 3;
              break;
            case 2:
              _context5.p = 2;
              _t5 = _context5.v;
              console.log(_t5);
            case 3:
              return _context5.a(2);
          }
        }, _callee5, this, [[0, 2]]);
      }));
      function headlineDeleteApi(_x5) {
        return _headlineDeleteApi2.apply(this, arguments);
      }
      return headlineDeleteApi;
    }(),
    headlineUploadPicApi: function () {
      var _headlineUploadPicApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee6() {
        var params, res, _t6;
        return (0, _regenerator2.default)().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              params = {
                modelId: this.modelId,
                pic: this.picImg
              };
              _context6.n = 1;
              return (0, _activeBinding.headlineUploadPicApi)(params);
            case 1:
              res = _context6.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
                this.headlineListApi();
                this.$parent.getHeaderMsg(this.modelId);
              }
              _context6.n = 3;
              break;
            case 2:
              _context6.p = 2;
              _t6 = _context6.v;
              console.log(_t6);
            case 3:
              return _context6.a(2);
          }
        }, _callee6, this, [[0, 2]]);
      }));
      function headlineUploadPicApi() {
        return _headlineUploadPicApi2.apply(this, arguments);
      }
      return headlineUploadPicApi;
    }()
  }
};